module.exports = __webpack_public_path__ + "img/drow_ranger.99cc7ecc.png";